import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { streamerBoxStreamerBoxDeviceServicesStop } from '@mi-front/api-v2';
import { Device, Service } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import { Stop as StopIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

interface PropsP {
  readonly stop: () => void;
  readonly disabled?: boolean;
}

/** Confirmation UI to stop a streamer-box service. */
export function ServiceStopP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamerBox.viewScreen.services.actions.stop.prompt',
        defaultMessage: '¿Deseas realmente detener el servicio?',
      })}
      onConfirm={async () => {
        try {
          await p.stop();
          notifyInfo(
            $t({
              id: 'streamerBox.viewScreen.services.actions.stop.done',
              defaultMessage: 'Detención de servicio solicitado',
            }),
          );
        } catch {
          notifyError(
            $t({
              id: 'streamerBox.viewScreen.services.actions.stop.error',
              defaultMessage: 'No se pudo detener el servicio',
            }),
          );
        }
      }}
    >
      {({ onClick }) => (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ marginLeft: 1 }}
          disabled={p.disabled}
          onClick={onClick}
          startIcon={<StopIcon />}
        >
          {$t({
            id: 'streamerBox.viewScreen.services.actions.stop.btn',
            defaultMessage: 'Detener',
          })}
        </Button>
      )}
    </ConfirmationAction>
  );
}

interface Props {
  readonly device: Device;
  readonly service: Service;
}

/** Stops a streamer-box service and reloads the parent AsyncView. */
export function ServiceStop(p: Props) {
  const { device, service } = p;
  const { reload } = useAsyncViewCtx();

  return (
    <ServiceStopP
      stop={async () => {
        await streamerBoxStreamerBoxDeviceServicesStop(String(device.id), service.imageId);
        reload();
      }}
      disabled={
        !['Running', 'Downloading', 'Installing', 'Downloaded', 'Restarting'].includes(
          service.status,
        )
      }
    />
  );
}
